<template>
  <div class="ibox col-md-12 pr-0 ta-banner roster-punch-card-front">
    <div class="ibox-title dashboard_title">
      <h4>Time and Attendance</h4>
    </div>
    <div class="ibox-content">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="row no-gutters">

            <template v-if="punch_data != null">
              <div class="col-lg-3 col-md-3 col-sm-6 pr-3 mb-2 mb-md-0 stat-col stat-col-half">
                <div class="px-2 py-1 radius-8 d-flex flex-row align-items-center">
                  <img src="/images/la/Punch-In%20Hover.svg" alt="">
                  <div class="pl-2">
                    <div class="text-small">Clocked in at:</div>
                    <div class="time">{{ punch_data.check_in }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 pr-3 mb-2 mb-md-0 stat-col stat-col-half">
                <div class="px-2 py-1 radius-8 d-flex flex-row align-items-center">
                  <img src="/images/la/Punch-Out%20Default.svg" alt="">
                  <div class="pl-2">
                    <div class="text-small">Clocked out at:</div>
                    <div class="time">{{ punch_data.check_out }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 pr-2 mb-2 mb-md-0 stat-col stat-col-full" v-if="roster == 1">
                <div class="px-2 py-1 radius-8 d-flex flex-row align-items-center">
                  <img src="/images/la/Current shift.svg" alt="">
                  <div class="pl-2">
                    <div class="text-small">Current Shift:</div>
                    <div class="time">{{ shift }}</div>
                  </div>
                </div>
              </div>
            </template>

          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12 pr-md-0 mt-3 mt-md-0 d-flex align-items-center pl-5 pb-4 ess-punch-actions">
            <b-button v-if="ess_punch == 1" class="text-white px-0 text-center mr-4 ml-2 ess-punch-btn radius-8" @click="punch">                
              <img class="punch-in" v-if="p_i_o_b_label == 'Punch In'" src="/images/la/Punch-In Default.svg" alt="">
              <img class="punch-out" v-else-if="p_i_o_b_label == 'Punch Out'" src="/images/la/Punch-Out Hover.svg" alt="">
              {{ p_i_o_b_label }}
            </b-button>

            <b-dropdown v-if="mobility == 1" :disabled="freezeFlag" id="dropdown-1" class="mr-2 rounded" toggle-class="mobility-toggle w-100" menu-class="w-100">
              <template #button-content>
                <img src="/images/la/Mobility Punch-In Default.svg" alt="">
                Mobility {{ p_i_o_b_label }}
              </template>
              <b-dropdown-item v-for="location in locations" :key="location.id" @click="showPunchInOutModal(location.id)">
                {{ location.location }}
              </b-dropdown-item>
            </b-dropdown>

            <div v-if="mobility == 1" class="roster-mobility-btn d-flex justify-content-center align-items-center cursor-pointer radius-8 bg-white" @click.prevent="showPendingListModal">
                <b-icon scale="1.4" icon="three-dots"></b-icon>
            </div>
        </div>
      </div>
    </div>

    <b-modal id="activity-pending-list" title="Mobility Attendance Pending List In Today" hide-footer>
      <div class="d-flex flex-row justify-content-end">


        <b-input-group class="date-range-picker d-flex flex-row align-items-end justify-content-start mb-0">
          <b-form-group id="date-group" label-for="date" class="mb-0">
            <b-input-group class="mb-0">
              <b-form-input @input="getPendingHistory(date)" id="date" name="date" v-model="date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :state="validateState('date')" aria-describedby="date-feedback" data-vv-as="Date"/>
              <b-input-group-append class="mb-0">
                <b-form-datepicker @input="getPendingHistory(date)" class="mb-0" :max="new Date()" id="day_two" button-only right locale="en-US" v-model="date" />
              </b-input-group-append>
              <b-form-invalid-feedback id="date-feedback">
                {{ veeErrors.first('date') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-input-group>

      </div>
      <div class="table-responsive mt-2">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky border">
          <thead class="table-head">
          <tr>
            <th>SL</th>
            <th>Mobility Type</th>
            <th>Punch Time</th>
            <th>Punch Type</th>
            <th>Remarks</th>
          </tr>
          </thead>
          <tbody>
          <template v-if="pending_list.length > 0">
            <tr v-for="(hit,index) in pending_list" class="hover-bg table-row border-bottom mx-2">
              <td>{{index + 1}}</td>
              <td>{{hit.location}}</td>
              <td>{{ moment(hit.attendances_time, "HH:mm").format("hh:mm A") }}</td>
              <td>{{hit.hit_type}}</td>
              <td class="leave-reason-wrapper">{{hit.remarks}}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="5" class="text-center">
              No Data Found.
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal id="pinch-in-or-out-modal" size="md" hide-footer :title="p_i_o_b_label">
      <b-form @submit.stop.prevent="submitWithLocation">

        <b-form-group>
          <b-form-input disabled :value="selectedLocation.location"></b-form-input>
        </b-form-group>
        <b-form-group v-if="selectedLocation.allow_specify == 1" label="Please Specify">
          <b-form-textarea id="remarks" name="remarks" rows="3" max-rows="6" no-resize v-model="fdata.remarks" data-vv-as="remarks"></b-form-textarea>
        </b-form-group>
        <div class="d-flex justify-content-center align-items-center">
          <b-button type="submit" :disabled="freezeFlag">
            {{p_i_o_b_label}}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import moment from "moment";
export default {
  data(){
    return {
      date: new Date().toISOString().slice(0, 10),
      punch_data: {
        check_in: 'N/A',
        check_out: 'N/A',
      },
      shift: 'N/A',
      ess_allowed: 0,
      p_i_o_b_label : 'Loading..',
      freezeFlag: false,
      cookie_btn_click_time: '',
      mobility: 0,
      locations:[],
      selectedLocation: {id:null, location:null},
      fdata:{
        remarks:'',
      },
      pending_list: [],
      ess_punch: 0,
      roster: 0,
    };
  },
  methods:{
    moment,
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster;
        }
      }.bind(this));
    },
    showPendingListModal(){
      this.getPendingHistory(this.date);
      this.$bvModal.show('activity-pending-list');
    },
    submitWithLocation(){
      if(this.freezeFlag == false)
      {
        let formData = new FormData()
        formData.append('mobility_id',this.selectedLocation.id)
        formData.append('remarks',this.fdata.remarks)
        axios.post(this.$api_url+'/front/leave-attendance/employee/attendance/mobile/punch' , formData).then(response => {
          if(response.data){
            this.$emit('childToParent',response.data);
            this.$bvToast.toast('Saved!', {
              title: `Punched Successfully`,
              variant: 'success',
              solid: true
            });
            if(response.data.last_activity == 'in'){
              this.p_i_o_b_label = 'Punch Out';
            }
            else
            {
              this.p_i_o_b_label = 'Punch In';
            }
            this.freezeFlag = true;
            setTimeout( () => {
                  this.freezeFlag = false
                },
                1000);

            location.reload();
          }

        }).catch(error => { this.serverError(error);});
      }
    },
    getMobilityLocations(){
      axios.get(this.$api_url+'/front/leave-attendance/attendance-mobility',{
        params:{
          type: 'list'
        }
      }).then(response => {
        this.locations = response.data;

      }).catch(error => {this.serverError(error);});
    },

    showPunchInOutModal(location){
      this.selectedLocation = this.locations.find(el => el.id == location)
      this.$bvModal.show('pinch-in-or-out-modal')
    },
    getPendingHistory(date) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return false;
      }
      let formData = new FormData();
      formData.append('date', date);
      axios.post(this.$api_url + '/front/leave-attendance/attendance/pending-history', formData).then(res=> {
        this.pending_list = res.data;
      });
    },
    punch(){
      axios.post(this.$api_url+'/front/leave-attendance/employee/attendance/punch').then(res => {
        location.reload();
      })
    },

    getPunchedInOrOut: function() {
      axios.get(this.$api_url+'/front/leave-attendance/employee/attendance/punch').then(response => {
        this.mobility = response.data.attendance_mobility;
        this.pending_list = response.data.pending_hits;
        this.freezeFlag = false;
        this.punch_data = response.data.data;
        this.ess_punch = response.data.ess_punch;

        this.shift = response.data.shift;
        if(this.mobility)
        {
          this.getMobilityLocations();
        }

        if(response.data.last_activity == 'in') {
          this.p_i_o_b_label = 'Punch Out';
        } else {
          this.p_i_o_b_label = 'Punch In';
        }
      }).catch(error => {
        this.serverError(error);
      });
    },
  },
  created(){
    this.getPunchedInOrOut();
    this.getCompanyLeaveSettings();
  }
}
</script>
